import ApiClient from '@afosto/api/ApiClient';

class Contacts {
  constructor(client) {
    this.apiClient = client || ApiClient;
  }

  /**
   * Delete a contact
   *
   * @param {string} id
   * @param {Object} options - The additional request options
   * @description Delete a contact by id
   * @returns {Promise}
   */
  deleteContact(id, options = {}) {
    return this.apiClient.request({
      url: `/rel/contacts/${id}`,
      method: 'delete',
      ...options,
    });
  }

  /**
   * View a single contact
   *
   * @param {string} id
   * @param {Object} query - The optional path parameters
   * @param {string} [query.version]
   * @param {Object} options - The additional request options
   * @description Returns a single contact by id
   * @returns {Promise}
   */
  getContact(id, query = {}, options = {}) {
    const params = {
      version: query.version,
    };

    return this.apiClient.request({
      url: `/rel/contacts/${id}`,
      method: 'get',
      params,
      ...options,
    });
  }

  /**
   * Get list of contacts
   *
   * @param {Object} options - The additional request options
   * @description Returns a list of contact information
   * @returns {Promise}
   */
  listContacts(options = {}) {
    return this.apiClient.request({
      url: `/rel/contacts`,
      method: 'get',
      ...options,
    });
  }

  /**
   * Search contacts
   *
   * @param {Object} body
   * @param {Object} options - The additional request options
   * @description Search contacts based on their id&#39;s or email addresses
   * @returns {Promise}
   */
  searchContacts(body, options = {}) {
    return this.apiClient.request({
      url: `/rel/contacts`,
      method: 'post',
      data: body,
      ...options,
    });
  }

  /**
   * Upsert a new contact
   *
   * @param {Object} body
   * @param {Object} options - The additional request options
   * @description Create or update an existing contact, based on its email address. This only updates the primary lists and moves existing primaries to the secondary lists when changed.
   * @returns {Promise}
   */
  upsertContact(body, options = {}) {
    return this.apiClient.request({
      url: `/rel/contacts`,
      method: 'put',
      data: body,
      ...options,
    });
  }

  /**
   * View a list of versions for a a single contact
   *
   * @param {string} id
   * @param {Object} options - The additional request options
   * @description Returns a version list for the contact
   * @returns {Promise}
   */
  viewContactVersions(id, options = {}) {
    return this.apiClient.request({
      url: `/rel/contacts/${id}/versions`,
      method: 'get',
      ...options,
    });
  }
}

export const contacts = new Contacts();

export default Contacts;
